/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import SimpleButton from "../../../core/button/SimpleButton";
import { _FilterButton } from "../styles";
var ToggleFilterButton = function ToggleFilterButton(_ref) {
  var onClick = _ref.onClick,
    has_filters = _ref.has_filters;
  return /*#__PURE__*/React.createElement(SimpleButton, {
    onClick: onClick,
    secondary: true
  }, /*#__PURE__*/React.createElement(_FilterButton, null, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "filter",
    className: has_filters ? 'active' : ''
  }), /*#__PURE__*/React.createElement("span", null, "Filter")));
};
export default ToggleFilterButton;